import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { commonAddressInputs, renderInputs } from "./utils";
import { useSubmit } from "module/common/components/forms";
import { putPropertyDetails } from "module/main/store/appEndpoints/api";
var PropertyDetails = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var curatedPayload = {
            property_details_lookups: [
                {
                    apn: request.apn || null,
                    fips: request.fips || null,
                    county: request.county || null,
                    street: request.street || null,
                    city: request.city || null,
                    state: request.state || null,
                    zipcode: request.zipcode || null,
                },
            ],
        };
        formSubmitCallBack(putPropertyDetails, curatedPayload);
    });
    var apnInputs = [
        { id: "apn", name: "apn", placeholder: "Enter APN", label: "APN" },
        { id: "fips", name: "fips", placeholder: "Enter FIPS", label: "FIPS" },
        { id: "county", name: "county", placeholder: "Enter County", label: "County" },
    ];
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Property details lookup:" }), _jsx("p", { className: "mb-4 text-sm text-mutedBlue", children: "Provide either an APN with FIPS, or APN with state and county, or a street address." }), _jsx("div", { className: "form-row", children: renderInputs(apnInputs) }), _jsx("h5", { className: "font-bold mb-2 inline", children: "Address:" }), _jsx("div", { className: "form-row", children: renderInputs(commonAddressInputs.slice(0, 2)) }), _jsx("div", { className: "form-row", children: renderInputs(commonAddressInputs.slice(2)) })] }));
};
export default PropertyDetails;
